"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const react_use_1 = require("react-use");
const mui_1 = require("tss-react/mui");
const Badge_1 = __importDefault(require("@mui/material/Badge"));
const core_1 = require("companion-app-components/utils/core");
const useStyles = (0, mui_1.makeStyles)()(() => ({
    badge: {
        opacity: 0.3,
        marginLeft: 15,
    },
    root: {
        width: '-webkit-fill-available',
        position: 'absolute',
    },
}));
const rendersTotals = {};
const RendersCount = (props) => {
    var _a;
    //////////////////////////////////////////////
    const { children, id, anchorOrigin, classes: restClasses } = props, rest = __rest(props, ["children", "id", "anchorOrigin", "classes"]);
    const { classes } = useStyles();
    const rendersCount = (0, react_use_1.useRendersCount)();
    const rendersCountPrev = (0, react_use_1.usePrevious)(rendersCount);
    const rendersTotal = (0, react_1.useMemo)(() => {
        var _a;
        if (id) {
            const rendersDelta = rendersCount - (rendersCountPrev !== null && rendersCountPrev !== void 0 ? rendersCountPrev : 0);
            rendersTotals[id] = ((_a = rendersTotals[id]) !== null && _a !== void 0 ? _a : 0) + rendersDelta;
        }
        return rendersTotals[id];
    }, [rendersCount, rendersCountPrev, id]);
    const shouldDisplayBadge = (_a = core_1.localPreferences.getItem('render-count')) !== null && _a !== void 0 ? _a : true;
    if (shouldDisplayBadge) {
        return (<Badge_1.default badgeContent={rendersTotal ? `${rendersCount} (${rendersTotal})` : rendersCount} color="primary" anchorOrigin={Object.assign({ vertical: 'top', horizontal: 'left' }, anchorOrigin)} classes={Object.assign({ badge: classes.badge, root: classes.root }, restClasses)} {...rest}>
        {children}
      </Badge_1.default>);
    }
    ///////////
    return props.children;
};
exports.default = RendersCount;
